<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <!-- <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      /> -->
      <div class="mx-1">
        <img src="/48.png" :height="60" />
      </div>
      <div
        class="mx-1"
      
      >
        <h5>{{getTitle()}}</h5>
      </div>
     

      <!-- <img src="logo" class="c-sidebar-brand-full"/>
  <img src="logo-minimized" class="c-sidebar-brand-minimized"/> -->
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="sidebarItems()" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";

export default {
  name: "TheSidebar",
  data() {
    return {title: ""};
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  methods: {
    getTitle() {
      if (process.env.VUE_APP_FIREBASE_AUTH_ENV == "production") {
        return "Edusign";
      }
      if (process.env.VUE_APP_FIREBASE_AUTH_ENV == "staging") {
        return "Edusign-Staging";
      }
    },
    currentItems() {
      console.log("role", this.$store.state.roles);
      let roles = this.$store.state.roles;

      let nNav = nav
        .map((item) => {
          if (item._name === "CSidebarNavDropdown") {
            let sItems = item.items
              .map((it) => {
                if (!it.roles) return it;
                if (it.roles.some((r) => roles.includes(r))) return it;
                return -1;
              })
              .filter((it) => it != -1);
            console.log("sItems", sItems);
            let nItem =
              sItems.length > 0 ? Object.assign(item, { items: sItems }) : -1;
            console.log("nItem", nItem);
            return nItem;
          }
          if (!item.roles) return item;
          if (item.roles.some((r) => roles.includes(r))) return item;
          return -1;
        })
        .filter((it) => it != -1);
      console.log("nNav", nNav);
      return nNav;
    },
    sidebarItems() {
      return [
        {
          _name: "CSidebarNav",
          _children: this.currentItems(),
        },
      ];
    },
  },
};
</script>
<style>
.c-sidebar {
  color: #fff;
  background: #5398ad;
}

a {
  text-decoration: none;
  background-color: transparent;
  color: #1fdb7d;
}

.c-sidebar a:hover:not(.active) {
  background-color: rgb(197, 195, 143);
  color: rgb(34, 31, 31);
}

.router-link-exact-active.c-active.c-sidebar-nav-link {
  background-color: rgb(197, 195, 143);
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #39f;
  border-color: #39f;
}
</style>





